import React, { useRef } from 'react'
import { Alert, Snackbar } from '@mui/material'

export type SnackbarState = {
  message: string
  severity: 'success' | 'error' | 'warning' | 'info'
} | null

type Props = {
  snackbar: SnackbarState
  onClose: () => void
}

const AppSnackbar: React.FC<Props> = ({ snackbar, onClose }) => {
  const lastSnackbar = useRef(snackbar)
  if (snackbar !== null) lastSnackbar.current = snackbar

  return (
    <Snackbar
      open={snackbar !== null}
      autoHideDuration={6000}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      onClose={onClose}
    >
      <Alert
        onClose={onClose}
        severity={lastSnackbar.current?.severity ?? 'info'}
        variant="filled"
        sx={{ width: '100%' }}
      >
        {lastSnackbar.current?.message}
      </Alert>
    </Snackbar>
  )
}

export default AppSnackbar
